<template>
  <ImageUpload
    class="team-view-header-logo"
    #default="{ imageSrc, chooseImage }"
    :disabled="disabled"
    @change="$emit('change', $event)"
    @error="handleError"
    :title="title"
  >
    <TeamLogo
      :src="imageSrc || value"
      alt=""
      color="second"
      @click.native="chooseImage"
    />
  </ImageUpload>
</template>

<script>
import ImageUpload from "@/components/ui/ImageUpload";
import TeamLogo from "./TeamLogo";
import { showAlert } from "@/core/common/";

export default {
  name: "TeamViewHeaderLogo",
  components: {
    ImageUpload,
    TeamLogo
  },
  model: {
    prop: "value",
    event: "change"
  },
  props: {
    value: {},
    disabled: Boolean
  },
  computed: {
    title() {
      return this.disabled ? "" : "Загрузить лого";
    }
  },
  methods: {
    handleError(data) {
      showAlert(data);
    }
  }
};
</script>
